export default __webpack_public_path__ + "static/media/notarias-color.eec7b302.svg";